module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('em', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/map"
    }
  }, [_vm._v("Map")])]), _vm._v(" "), _c('p', {
    staticClass: "toc t"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("1")]), _vm._v(" The Original Coffin Road: Kilmartin Valley")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("2")]), _vm._v(" Towards the Shrine of a Saint: The Street of the Dead, Iona")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("3")]), _vm._v(" Intimations of Heaven: Jura")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("4")]), _vm._v(" Watching over the Churchyard: Morvern")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("5")]), _vm._v(" Islands of Graves: The Green Isle, Loch Shiel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("6")]), _vm._v(" Death Croons and Soul Leadings: The Piper’s Cairn, Eigg")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("7")]), _vm._v(" Premonitions and Apparitions: Kintail")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("8")]), _vm._v(" Wakes and Whisky: Barra")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("9")]), _vm._v(" Epilogue: Revisiting the Coffin Roads Today")])]), _vm._v(" "), _c('p', {
    staticClass: "toc t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0